import { Pipe, PipeTransform } from '@angular/core';

import { Feature } from '@vi-iot/client';

import { TemperatureRangeDefinition } from '../../features/temperature/converter/converter';

@Pipe({
  name: 'constraints',
})
export class ConstraintsPipe implements PipeTransform {
  transform(feature: Feature<unknown, unknown>, ...args: any[]): TemperatureRangeDefinition | null {
    if (!args || !args[0] || !args[1]) {
      return null;
    }
    const command = args[0];
    const param = args[1];
    const isExecutable = !!(
      feature &&
      feature.commands &&
      feature.commands[command] &&
      feature.commands[command].isExecutable
    );
    const isParam = !!(
      isExecutable &&
      feature.commands[command].params &&
      feature.commands[command].params[param] &&
      feature.commands[command].params[param].constraints
    );

    return isExecutable && isParam && feature.commands[command].params[param].constraints;
  }
}
